"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidChainId = exports.isDapperProvider = exports.isCucumberProvider = exports.getConnectedProviderType = exports.getConnectedProvider = exports.createProvider = void 0;
const schemas_1 = require("@dcl/schemas");
const decentraland_connect_1 = require("decentraland-connect");
const utils_1 = require("./utils");
function createProvider(providerType, chainId) {
    return __awaiter(this, void 0, void 0, function* () {
        return decentraland_connect_1.connection.createProvider(providerType, chainId);
    });
}
exports.createProvider = createProvider;
function getConnectedProvider() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const { provider } = yield decentraland_connect_1.connection.tryPreviousConnection();
            return provider ? provider : null;
        }
        catch (error) {
            return null;
        }
    });
}
exports.getConnectedProvider = getConnectedProvider;
function getConnectedProviderType() {
    const connectionData = decentraland_connect_1.connection.getConnectionData();
    return connectionData ? connectionData.providerType : null;
}
exports.getConnectedProviderType = getConnectedProviderType;
function isCucumberProvider() {
    const provider = window.ethereum;
    return utils_1.isMobile() && !!provider && !!provider.isCucumber;
}
exports.isCucumberProvider = isCucumberProvider;
function isDapperProvider() {
    const provider = window.ethereum;
    return !!provider && !!provider.isDapper;
}
exports.isDapperProvider = isDapperProvider;
function isValidChainId(chainId) {
    return Object.values(schemas_1.ChainId).includes(Number(chainId));
}
exports.isValidChainId = isValidChainId;
//# sourceMappingURL=eth.js.map